import styled, { keyframes } from 'styled-components';
import React, { useEffect, useCallback, useState, useRef } from "react";


const Screen1 = () => {
    const [selected, setSelected] = useState(false);

    return (
        <Container>
            <Question>
                Would you like to to be guided through the plan building process?
            </Question>

            <Responses>
                <Response selected={selected==1} onClick={()=>setSelected(1)}>
                    Yes, I would like to be guided through the plan building process
                </Response>
                <Response selected={selected==2} onClick={()=>setSelected(2)}>
                    No, I would prefer to write me own plan from scratch
                </Response>
            </Responses>
        </Container>
    )

}

export default Screen1;

const Container = styled.div`
    width:100%;
    font-family:"Raleway";
`

const Question = styled.div`
    font-size:28px;
    margin-bottom:40px;
    font-weight:600;
    line-height:1.2
`

const Responses = styled.div`
    display:flex;
    flex-direction:column;
`

const Response = styled.div`
    padding:20px;
    border:1px solid #ccc;
    margin-bottom:10px;
    cursor:pointer;

    background-color:${props=>props.selected ? "#f0f0f0" : "white"};
    color:${props=>props.selected ? "#333" : "#666"};
    transition:0.3s;
`

